/** Game mode ids, as levels name them in `Zone.gameMode`: apart from the modes' code, which loads lazily. */
export const GM_SHOWCASE = "GM_Showcase";
